/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgZone } from '@angular/core';
import { Control } from 'ol/control';

import { GoogleControlConfig } from '../../../types/Google';

export class GoogleTrafficControl extends Control {
    private readonly _layerConfigs: Map<string, GoogleControlConfig>;
    private trafficEnabled: boolean;
    private zone: NgZone;

    constructor(optOptions) {
        const defaultOptions = {};
        const options = { ...defaultOptions, ...optOptions };
        const element: HTMLDivElement = document.createElement('div');
        super({
            ...options,
            ...{ element: element, target: options.target },
        });
        this.trafficEnabled = false;
        this.init(options, element);
    }

    public setZone(zone: NgZone): GoogleTrafficControl {
        this.zone = zone;
        return this;
    }

    private init(options, element) {
        element.classList.add('traffic-toggle');
        element.classList.add('ol-unselectable');
        element.classList.add('ol-control');

        const button: HTMLButtonElement = document.createElement('button');
        button.innerText = options.labels[+this.trafficEnabled];
        button.id = 'button_traffic_toggle';

        const setLayerListener = () => {
            this.trafficEnabled = !this.trafficEnabled;
            options.callback(this.trafficEnabled);
            button.innerText = options.labels[+this.trafficEnabled];
        };
        button.addEventListener('click', setLayerListener);
        button.addEventListener('touchstart', setLayerListener);
        element.appendChild(button);
    }
}
